import { Theme } from "@mui/material";

export const getQuoteStyles = (theme: Theme) => ({
  borderLeft: `2px solid ${theme.palette.primary.main}`,
  pl: 2.5,
});

export const listStyles = {
  color: "text.secondary",
  fontSize: { xs: "1rem", md: "1.125rem" },
};
